export enum ReduxRevenueSourcerType {
  SET_ALL_REVENUE_MASTER = 'SET_ALL_REVENUE_MASTER',
  SET_VERIFIED_REVENUE_MASTER = 'SET_VERIFIED_REVENUE_MASTER',
  SET_REVENUE_WITH_REQUEST = 'SET_REVENUE_WITH_REQUEST'
}
